import { Component } from '@nicolas-riciotti/light2';

export default class BlockNav extends Component {
    attached() {
        this.$links = Array.from(this.querySelectorAll('a[data-nav-target]'));
        this.entries = [];

        this.$links.forEach((link) => {
            const targetSelector = link.getAttribute('data-nav-target');
            if (!targetSelector || targetSelector === '#') return;
            let section = null;
            try {
                section = document.querySelector(targetSelector);
            } catch (e) {}
            if (section) {
                this.entries.push({ link, section });
            }
        });

        if (!this.entries.length) return;

        this.onIntersect = this.onIntersect.bind(this);
        this.observer = new IntersectionObserver(this.onIntersect, {
            rootMargin: '-40% 0px -55% 0px',
            threshold: 0,
        });
        this.entries.forEach(({ section }) => this.observer.observe(section));
    }

    onIntersect(intersectingEntries) {
        intersectingEntries.forEach((intersection) => {
            if (!intersection.isIntersecting) return;
            const activeSection = intersection.target;
            this.entries.forEach(({ link, section }) => {
                link.classList.toggle('is-active', section === activeSection);
            });
        });
    }

    detached() {
        this.observer?.disconnect();
    }
}

customElements.define('block-nav', BlockNav);
